// extracted by mini-css-extract-plugin
module.exports = {"container":"Hook_container__89EIH","info":"Hook_info__6ec89","name":"Hook_name__dtJra","title":"Hook_title__tnLDk","sub":"Hook_sub__7jmTb"};